<div
  class="vm-accordion-item"
  [ngClass]="{
    'vm-accordion-item__isopen': state == 'isOpen',
    'vm-accordion-item__isclosed': state == 'isClosed'
  }"
>
  <ng-content select="vm-accordion-title-bar"></ng-content>
  <div [id]="id" [@accordionItemContentAnimation]="state">
    <div class="vm-accordion-item__content" [hidden]="!isActive">
      <ng-content></ng-content>
    </div>
  </div>
</div>
